@if (recommendations?.length) {
  <div class="m-t-5"
    >
    <h5 *iCms="'fashionRecHeading' of productViewLayout.content"
      class="h2"
    text></h5>
    <!-- desktop recommendations -->
    <div class="m-t-10"
      *ifSize="'XL'">
      @for (recommendation of recommendations; track $index) {
        <recommendation-item class="w-4 p-t-9"
        [recommendation]="recommendation"></recommendation-item>
      }
    </div>
    <!-- mobile recommendations -->
    <div class="m-t-10 p-t-5"
      *ifSize="'SM'">
      <swiper [slidesPerView]="2.5"
        [centeredSlidesBounds]="true">
        @for (recommendation of recommendations; track $index) {
          <ng-template swiperSlide>
            <recommendation-item [recommendation]="recommendation"></recommendation-item>
          </ng-template>
        }
      </swiper>
    </div>
  </div>
}
